import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshing = null;
let onSessionLost = () => {};

export function setSessionLostHandler(fn) {
  onSessionLost = fn;
}

export function refreshSession() {
  if (!refreshing) {
    refreshing = axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/refresh`, null, { withCredentials: true })
      .finally(() => { refreshing = null; });
  }
  return refreshing;
}

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const cfg = error.config || {};
    const status = error.response?.status;
    const detail = error.response?.data?.detail;
    if (status === 403 && detail === "account_suspended") onSessionLost("suspended");
    if (status !== 401 || cfg._retried || NO_REFRESH.some((p) => cfg.url?.startsWith(p))) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    try {
      await refreshSession();
    } catch {
      onSessionLost("expired");
      return Promise.reject(error);
    }
    try {
      return await api(cfg);
    } catch (e) {
      if (e.response?.status === 401) onSessionLost("expired");
      throw e;
    }
  },
);

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function track(event, props) {
  api.post("/analytics", { event, props }).catch(() => {});
}

export default api;
